import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { i18nStyleguideEn } from './en/styleguide';
import { i18nStyleguideEs } from './es/styleguide';

const i18nInstance = i18n.createInstance();

i18nInstance
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    defaultNS: 'styleguide',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources: {},
  });

i18nInstance.addResourceBundle('en', 'styleguide', i18nStyleguideEn);
i18nInstance.addResourceBundle('es', 'styleguide', i18nStyleguideEs);

export { i18nInstance };
